export const UPDATE_CURRENT_MESSAGE = 'CommunityMessage/UPDATE_CURRENT_MESSAGE';

export function updateCurrentMessage(id) {
  return {
    type: UPDATE_CURRENT_MESSAGE,
    payload: { id }
  };
}



// WEBPACK FOOTER //
// ./src/containers/CommunityMessageContainer/actions.js